import * as React from 'react';
import Typography from '@mui/material/Typography';

import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TodayIcon from '@mui/icons-material/Today';

type DayTimelineItemProps = {
  dayOfWeek?: "Sunday" | "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "", 
  title?: string
  date?: string
};

const defaultProps: DayTimelineItemProps = {
}

export default function DayTimelineItem(dayTimelineItemProps: DayTimelineItemProps = defaultProps) {
  return (
    <TimelineItem>
      <TimelineOppositeContent
          sx={{ 
            my: "11.5px", 
            ml: 'auto', 
            mb: "auto", 
            pl: 1, 
            py: '0', 
            pr: 2, 
            lineHeight: "36px", 
            verticalAlign: "middle", 
            fontWeight: "bold",
            width: "119px",
            minWidth: "119px",
            maxWidth: "119px",
            color: "black"
          }}
          align="right"
          variant="h4"
          color="text.secondary"
        >
          {dayTimelineItemProps.date ? dayTimelineItemProps.date : ""}
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot sx={{backgroundColor: "darkblue"}}>
            <TodayIcon />
          </TimelineDot>
          <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent
        variant="h4"
        sx={{ 
          my: "11.5px", 
          ml: '0', 
          pr: 2, 
          pt: '0', 
          pb: '1em', 
          lineHeight: "36px", 
          verticalAlign: "middle", 
          fontWeight: "bold",
          color: "black",
          width: "100%" 
        }}>
        {dayTimelineItemProps.dayOfWeek ? dayTimelineItemProps.dayOfWeek : ""}
      </TimelineContent>
    </TimelineItem>
  );
}
